var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _vm.currentComponent
      ? _c(
          "div",
          {},
          [
            _c("span", [_vm._v(_vm._s(_vm.formattedTime))]),
            _vm._v(" "),
            _c("simple-link", { attrs: { target: _vm.wikiLog.actor } }),
            _vm._v(" "),
            _c(_vm.currentComponent, {
              tag: "component",
              attrs: { wikiLog: _vm.wikiLog },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }